import React from "react";
import { AllIconNames } from "react-ui";

import { Icon } from "../../Icons/Icon";

import { InfoBlockHeader, InfoBlockIconWrapper, InfoBlockWrapper } from "./InfoBlock.styles";
import { InfoBlockType } from "./InfoBlockType";

export interface ClueProps {
    header?: string;
    icon: AllIconNames | "";
    children?: React.ReactNode;
    type: InfoBlockType;
}

export const InfoBlock = (props: ClueProps) => (
    <InfoBlockWrapper type={props.type ?? InfoBlockType.info}>
        {props.icon !== "" && (
            <InfoBlockIconWrapper>
                <Icon name={props.icon} />
            </InfoBlockIconWrapper>
        )}
        <div>
            {props.header && <InfoBlockHeader>{props.header}</InfoBlockHeader>}
            <div>{props.children}</div>
        </div>
    </InfoBlockWrapper>
);
